import { ForgotPassword } from "pages/ForgotPassword/ForgotPassword";

export default ForgotPassword;
